import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledContactForm = styled(Box)({
  width: "50vw",
  padding: "2rem 5rem",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    ".input-small": {
      display: "flex",
      width: "100%",
      gap: "10%",
      ">div": {
        width: "45%",
      },
    },
    ">div p": {
      fontSize: ".9rem",
      fontWeight: "100",
    },
    button: {
      width: "50%",
    },
  },
  "@media (max-width: 1280px)": {
    width: "100%",
    padding: "1rem",
  },
});
